<template>
  <div class="common-box">
    <el-form
      inline
      ref="form"
      class="search-form common-box-search-form"
      label-position="right"
      :model="form"
      label-width="70px"
    >
      <search-form
        @search="handleSearch"
        @refresh="handleRefresh"
      >
        <div slot="content">
          <el-form-item label="单位名称：">
            <el-input
              @change="handleSearchListData"
              size="mini"
              v-model.trim="form.unitName"
              placeholder="请输入单位名称"
              clearable
            ></el-input>
          </el-form-item>
          <el-form-item label="联系人：">
            <el-input
              @change="handleSearchListData"
              size="mini"
              v-model.trim="form.principal"
              placeholder="请输入联系人"
              clearable
            ></el-input>
          </el-form-item>
          <el-form-item label="详细地址：">
            <el-input
              @change="handleSearchListData"
              size="mini"
              v-model.trim="form.address"
              placeholder="请输入详细地址"
              clearable
            ></el-input>
          </el-form-item>
          <el-form-item label="联系电话：">
            <el-input
              @change="handleSearchListData"
              size="mini"
              v-model.trim="form.principalPhone"
              placeholder="请输入联系电话"
              clearable
            ></el-input>
          </el-form-item>
          <el-form-item label="客服电话：">
            <el-input
              @change="handleSearchListData"
              size="mini"
              v-model.trim="form.consumerHotLine"
              placeholder="请输入客服电话"
              clearable
            ></el-input>
          </el-form-item>


        </div>
      </search-form>
    </el-form>
    <div class="common-cover-div"></div>
    <div class="operation-and-table__container">
      <div class="btns__container">
        <el-button v-if="hasRole['SYDWTJ']" size="mini" type="primary" class="plr28" @click="handleAdd">添加</el-button>
        <el-button
          size="mini"
          type="primary"
          class="plr28"
          @click="handleDelete"
          plain
          v-if="hasRole['SYDWSC']"
        >删除</el-button>
        <el-button
          size="mini"
          type="primary"
          @click="exportUnit"
          plain
          class="plr28"
          v-if="hasRole['SYDWDC']"
        >导出</el-button>
      </div>
      <div class="table__container">
        <el-table
          v-loading="tableLoading"
          :data="list"
          height="100%"
          border
          style="width: 100%"
          @selection-change="handleSelectionChange"
        >
          <el-table-column type="selection" width="40"></el-table-column>
          <el-table-column show-overflow-tooltip prop="unitName" label="单位名称" width="150"></el-table-column>
          <el-table-column show-overflow-tooltip prop="grade" label="客户等级" width="80"></el-table-column>

          <el-table-column show-overflow-tooltip prop="creditCode" label="省市区" width="200">
            <template slot-scope="scope">
              {{scope.row.provinceName}},{{scope.row.cityName}},{{scope.row.districtName}}
            </template>
          </el-table-column>
          <el-table-column show-overflow-tooltip prop="address" label="地址" width="200"></el-table-column>
          <el-table-column show-overflow-tooltip prop="principal" label="联系人" width="100"></el-table-column>
          <el-table-column show-overflow-tooltip prop="principalPhone" label="联系电话" width="100"></el-table-column>
      		<el-table-column show-overflow-tooltip prop="consumerHotLine" label="客服电话" width="100"></el-table-column>
          <el-table-column show-overflow-tooltip prop="createTime" label="创建时间" width="100"></el-table-column>
      		<el-table-column label=" " prop=" "></el-table-column>
          <el-table-column label="操作" width="98px" fixed="right">
            <template slot-scope="scope">
              <el-button size="mini" v-if="hasRole['SYDWBJ']" type="text" @click="handleEdit(scope.row)">编辑</el-button>
              <div class="btn-divide" v-if="hasRole['SYDWBJ']"></div>
              <el-button size="mini" v-if="hasRole['SYDWSC']" type="text" @click="handleDeleteUnit(scope.row)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="pagenation__container">
        <div class="for-fff-bg">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="pageIndex"
            :page-sizes="[25, 50, 100, 150, 200]"
            :page-size="pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total"
          ></el-pagination>
        </div>
      </div>
    </div>
    <add-unit
      v-if="addUnitVisible"
      @cancel="addUnitVisible = false"
      @confirm="handleAddUnitConfirm"
    ></add-unit>
    <edit-unit
      v-if="editUnitVisible"
      :editData="unitDetail"
      @cancel="editUnitVisible = false"
      @confirm="handleEditUnitConfirm"
    ></edit-unit>
    <check-unit
      v-if="checkUnitVisible"
      :editData="unitDetail"
      @cancel="checkUnitVisible = false"
    ></check-unit>
    <check-department
      v-if="checkDepartment"
      :editData="unitDetail"
      @cancel="checkDepartment = false"
    ></check-department>
  </div>
</template>

<script>

  import { getUnitList, deleteUnit, exportUnit } from '@/api/UseUnits'

  import AddUnit from './components/AddUnit'
  import EditUnit from './components/EditUnit'
  import CheckUnit from './components/CheckUnit'
  import CheckDepartment from './components/CheckDepartment'
  export default {
    name: 'UseUnits',
    components: {
      AddUnit,
      EditUnit,
      CheckUnit,
      CheckDepartment
    },
    data() {
      return {
        form: {
          unitName: '',
          principal: '',
          principalPhone: '',
          consumerHotLine: '',
          address: ''

        },
        tableLoading: false,
        list: [],
        multipleSelection: [],
        pageIndex: 1,
        pageSize: 50,
        total: 0,
        addUnitVisible: false,
        editUnitVisible: false,
        checkUnitVisible: false,
        checkDepartment: false,
        unitDetail: {}
      }
    },
    computed: {
      hasRole: function() {
        return this.$store.getters['common/promise/getRole'](this.$route.path);
      }
    },
    created() {
      this.getListData()
    },
    methods: {
      async getListData() {
       this.tableLoading = true
       const params = {
         pageIndex: this.pageIndex,
         pageSize: this.pageSize
       }
       for(let key in this.form) {
         if (this.form[key])
          params[key] = this.form[key]
       }
        const res = await getUnitList(params)
        if (res.code === 200) {
          this.total = res.data.total
          this.list = res.data.list
        }
        this.tableLoading = false
      },
      handleSearch() {
        this.pageIndex = 1
        this.getListData()
      },
      handleRefresh() {
        for(let key in this.form) {
          if (Array.isArray(this.form[key])) {
            this.form[key] = []
          } else {
            this.form[key] = ''
          }
        }
        this.pageIndex = 1
        this.getListData()
      },
      handleSearchListData() {
        this.pageIndex = 1
        this.getListData()
      },
      handleSelectionChange(val) {
        this.multipleSelection = val
      },
      handleDeleteUnit(row) {
        const idList = [row.id]
        this.deleteUnit(idList)
      },
      handleCheck(row) {
        this.unitDetail = row
        this.checkDepartment = true
      },
      handleEdit(row) {
        this.unitDetail = row
        this.editUnitVisible = true
      },
      handleDelete() {
        if (!this.multipleSelection.length) {
          this.$message.warning('请选择要删除的行')
          return
        }
        const idList = this.multipleSelection.map(item => item.id)
        this.deleteUnit(idList)
      },
      deleteUnit(idList) {
        this.$confirm('确定删除?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(async () => {
          const res = await deleteUnit({idList})
          if (res.code === 200) {
            this.$message.success('删除成功')
            this.getListData()
          }
        }).catch((err) => {
          console.log(err)
        })

      },
      handleAdd() {
        this.addUnitVisible = true
      },
      exportUnit() {
        const params = {
          pageIndex: this.pageIndex,
          pageSize: this.pageSize
        }
        for(let key in this.form) {
          if (this.form[key])
            params[key] = this.form[key]
        }
        exportUnit(params)
      },
      handleSizeChange(val) {
        this.pageSize = val
        this.getListData()
      },
      handleCurrentChange(val) {
        this.pageIndex = val
        this.getListData()
      },
      handleAddUnitConfirm () {
        this.addUnitVisible = false
        this.pageIndex = 1
        this.getListData()
      },
      handleEditUnitConfirm () {
        this.editUnitVisible = false
        this.getListData()
      },

    }
  }
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/pages/useUnits/UseUnits.vue